export default {"src":"/_next/static/media/folders.c06cd11c.svg","height":20,"width":20};